import { PropsWithChildren } from 'react';

import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { HelmetProvider } from 'react-helmet-async';

import { theme, GlobalStyles } from './styles';
import { ScrollContextProvider } from './context/ScrollContext';

export const Providers = ({ children }: PropsWithChildren) => {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />
        <ScrollContextProvider>{children}</ScrollContextProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
};
